import { createSafeContext } from '@mantine/core';

import { AdditionalFieldOption } from './AdditionalFields.types';
import { UseAdditionalFieldsReturn } from './useAddAdditionalFields';

type CheckboxOverride = {
  propName: keyof AdditionalFieldOption;
  renderCheckbox: (checkbox: React.ReactElement) => React.ReactElement;
  label: string;
};

type AdditionalFieldsProvider = {
  isOrderable?: boolean;
  isDisabled?: boolean;
  checkboxOverride?: CheckboxOverride;
} & UseAdditionalFieldsReturn;

const [AdditionalFieldsProvider, useAdditionalFieldsContext] =
  createSafeContext<AdditionalFieldsProvider>(
    'AdditionalFieldsProvider component was not found in tree'
  );

export { AdditionalFieldsProvider, useAdditionalFieldsContext };

export type { CheckboxOverride };
